import { store } from '@betacrew/jars-flux'
import { EXPORT_RECIPIENT_DRAWER_LOADING_STATES } from './constants';

export const componentKey = "EXPORT_RECIPIENTS_DATA";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setFormsList: (state, action) => {
            state.formsList = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setSelectedExportType: (state, action) => {
            state.selectedExportType = action.payload;
        }
    },

    initialReducerState: {
        loadingState: { state: EXPORT_RECIPIENT_DRAWER_LOADING_STATES.EXPORT_RECIPIENT_FORMS_LOADING },
        formsList: [],
        selectedForm: { label: "", value: "" },

        selectedExportType: { label: "", value: "" }
    }
})

export const { setFormsList, setSelectedForm, setSelectedExportType, setLoadingState } = actions;